import React from 'react';
import ProgressIndicator from '@/components/ui/ProgressIndicator';
import { CATEGORIES, useWizard } from './WizardContext';

export default function ProfileEditProgressIndicator() {
  const { activeStepId, completedStepIds } = useWizard();
  return (
    <div className="px-6 pt-6 pb-4">
      <ProgressIndicator
        steps={CATEGORIES}
        activeStepId={activeStepId}
        completedStepIds={completedStepIds}
      />
    </div>
  );
}
